// @ts-nocheck

const basketItemSetMPCard = (state, action) => {
  const { items } = state;
  const { oddsId, familyId, index } = action.payload;

  const item = items[oddsId];

  if (item) {
    return {
      ...state,
      items: {
        ...items,
        [oddsId]: {
          ...item,
          monopolyCard: {
            familyId,
            index,
          },
        },
      },
    };
  }

  return state;
};

export default basketItemSetMPCard;
